export default __webpack_public_path__ + "static/media/telemed_icon_active.e2b5d4e3.svg";